
export const TESTING_BACKGROUND_CLASS = "testing-background"

export const addTestingBackground = () => {
    let root = document.getElementById('root');
    root?.classList.add("testing-background");
    root?.style.setProperty("background-image", `url("/test-text-tranparent.svg")`);
};


export const removeTestingBackground = () => {
    let root = document.getElementById('root');
    root?.classList.remove("testing-background");
    root?.style.setProperty("background-image", "none");
};